import { DEFAULT_ENTRY_ID } from '@databases/types/database';
import { DatabaseChangeType } from '@databases/types/redux';

import { dbFieldTypeMap, fieldToCollabJSON } from '../../../collab/convert-to-collab';
import { YJSChangeHandler } from '../../types';
import { applyDeltaValue } from '../../utils/apply-delta-value';
import { getOrSetValue } from '../../utils/get-or-set-value';

export const createFieldAndSetValue: YJSChangeHandler<
  DatabaseChangeType.CREATE_FIELD_AND_SET_VALUE
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    const delta = change.change;
    if (!delta) {
      return;
    }

    const entry =
      change.entryId === DEFAULT_ENTRY_ID
        ? db.defaultEntry
        : db.entriesById[change.entryId];

    const field = db.fieldsById[change.field.id] || change.field;

    if (!entry || !field) {
      return;
    }

    const destType = dbFieldTypeMap[delta.type];

    if (!destType) {
      throw new Error('unsupported type ' + destType);
    }

    // add field
    if (change.index !== undefined) {
      db.addFieldAt(change.field.id, fieldToCollabJSON(change.field, {}), change.index);
    } else {
      db.addFieldFromJSON(change.field.id, fieldToCollabJSON(change.field, {}));
    }

    db.views.forEach((viewId: string) => {
      if (db.viewsById[viewId] && db.viewsById[viewId].fields) {
        db.viewsById[viewId].setFieldVisibility(change.field.id, true, db.fields, {
          includeNewFieldInValidation: true,
        });
      }
    });

    // set value
    applyDeltaValue((destType) => getOrSetValue(entry, change.field.id, destType), delta);
  });
};
